import type { ReactNode } from 'react';
import type { ExperienceMode } from '@localagent/sdk';

export function SettingsChrome({
  mode,
  settingsExtras,
  display,
  backendConnection,
  shogunChop,
  midSections,
  errorHistory,
  afterError,
  tenantIds,
  tenantActions,
}: {
  mode: ExperienceMode | undefined;
  settingsExtras?: ReactNode;
  display: ReactNode;
  backendConnection: ReactNode;
  shogunChop: ReactNode;
  midSections: ReactNode;
  errorHistory: ReactNode;
  afterError: ReactNode;
  tenantIds: ReactNode;
  tenantActions: ReactNode;
}) {
  const showDiagnostics = mode === 'advanced';
  return (
    <>
      {display}
      {showDiagnostics ? backendConnection : null}
      {shogunChop}
      {midSections}
      {errorHistory}
      {afterError}
      <section className="space-y-4">
        {showDiagnostics ? tenantIds : null}
        {tenantActions}
      </section>
      {settingsExtras}
    </>
  );
}
